import dynamic from 'next/dynamic';
import { HotelInformationProps } from './HotelInformationComponent';

export const HotelInformation = dynamic<HotelInformationProps>(() => import('./HotelInformationComponent'));
